export default "__VITE_ASSET__CxkGmCWJ__"